import { Picker } from '@veeva/corgix/picker';
import { Menu, MenuItem } from '@veeva/corgix/menu';
import { useContext } from 'react';
import { ThemeProvider } from 'emotion-theming';
import Languages from '../../services/i18n/Languages';
import UnauthenticatedRouteLanguageContext from '../../services/UnauthenticatedRouteLanguageContext';

const theme = {
    dropdownMenuWidthMD: 'max-content',
    menuSpacing: '1rem',
    menuSpacingVariant1: '1rem',
    menuFontSize: '1.33rem',
};

export default function FooterLanguageSelect({ placement }) {
    const { messageLanguage, setMessageLanguage } = useContext(UnauthenticatedRouteLanguageContext);

    const handleChange = (event, value) => {
        setMessageLanguage(value);
    };

    const languageLabels = Object.values(Languages).map((k) => `${k.label}`);
    const items = Object.keys(Languages).map((k, i) => {
        return (
            <MenuItem key={k} value={k}>
                {languageLabels[i]}
            </MenuItem>
        );
    });

    return (
        <ThemeProvider theme={theme}>
            <Picker
                value={messageLanguage}
                onChange={handleChange}
                variant="ghost"
                placement={placement}
            >
                <Menu>{items}</Menu>
            </Picker>
        </ThemeProvider>
    );
}
